import { render, staticRenderFns } from "./colorProviderListItem.vue?vue&type=template&id=3e0cef9e"
import script from "./colorProviderListItem.vue?vue&type=script&lang=js"
export * from "./colorProviderListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports